!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("classnames"), require("@material-ui/icons/FormatBold"), require("@material-ui/icons/FormatListBulleted"), require("@material-ui/icons/FormatListNumbered"), require("@material-ui/icons/FormatItalic"), require("@material-ui/icons/FormatUnderlined"), require("@material-ui/icons/SpaceBar"), require("@material-ui/icons/Code"), require("@material-ui/icons/StrikethroughS"), require("draft-js"), require("@material-ui/core")) : "function" == typeof define && define.amd ? define(["exports", "react", "classnames", "@material-ui/icons/FormatBold", "@material-ui/icons/FormatListBulleted", "@material-ui/icons/FormatListNumbered", "@material-ui/icons/FormatItalic", "@material-ui/icons/FormatUnderlined", "@material-ui/icons/SpaceBar", "@material-ui/icons/Code", "@material-ui/icons/StrikethroughS", "draft-js", "@material-ui/core"], t) : t((e = e || self)["comment-field"] = {}, e.React, e.classNames, e.FormatBold, e.FormatListBulleted, e.FormatListNumbered, e.FormatItalic, e.FormatUnderlined, e.SpaceBar, e.Code, e.StrikethroughS, e.draftJs, e.core);
}(this, function (e, t, o, r, n, a, l, i, c, u, d, s, m) {
  "use strict";

  var p = "default" in t ? t.default : t;
  o = o && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o, r = r && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r, n = n && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n, a = a && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a, l = l && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l, i = i && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i, c = c && Object.prototype.hasOwnProperty.call(c, "default") ? c.default : c, u = u && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u, d = d && Object.prototype.hasOwnProperty.call(d, "default") ? d.default : d;
  var f = {
    CODE: {
      fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
      padding: 2
    },
    STRIKETHROUGH: {
      textDecoration: "line-through"
    }
  };

  function g(e) {
    switch (e.getType()) {
      case "blockquote":
        return "RichEditor-blockquote";

      default:
        return "";
    }
  }

  var y = function y(e) {
    var t = e.onToggle,
        o = e.style,
        r = e.label,
        n = e.active,
        a = e.Icon;
    return p.createElement(m.Tooltip, {
      title: r,
      placement: "top",
      PopperProps: {
        popperOptions: {}
      }
    }, p.createElement(m.IconButton, {
      size: "small"
    }, p.createElement(a, {
      fontSize: "small",
      color: n ? "secondary" : void 0,
      onMouseDown: function onMouseDown(e) {
        e.preventDefault(), t(o);
      }
    }, r)));
  },
      b = [{
    label: "Bulleted List",
    icon: n,
    style: "unordered-list-item"
  }, {
    label: "Numbered List",
    icon: a,
    style: "ordered-list-item"
  }, {
    label: "Code Block",
    icon: u,
    style: "code-block"
  }],
      h = function h(e) {
    var t = e.onToggle,
        o = e.editorState,
        r = o.getSelection(),
        n = o.getCurrentContent().getBlockForKey(r.getStartKey()).getType();
    return p.createElement(p.Fragment, null, b.map(function (e) {
      return p.createElement(y, {
        key: e.label,
        active: e.style === n,
        label: e.label,
        onToggle: t,
        style: e.style,
        Icon: e.icon
      });
    }));
  },
      S = [{
    label: "Bold",
    icon: r,
    style: "BOLD"
  }, {
    label: "Italic",
    icon: l,
    style: "ITALIC"
  }, {
    label: "Underline",
    icon: i,
    style: "UNDERLINE"
  }, {
    label: "Strikethrough",
    icon: d,
    style: "STRIKETHROUGH"
  }, {
    label: "Monospace",
    icon: c,
    style: "CODE"
  }],
      E = function E(e) {
    var t = e.onToggle,
        o = e.editorState.getCurrentInlineStyle();
    return p.createElement(p.Fragment, null, S.map(function (e) {
      return p.createElement(y, {
        key: e.label,
        active: o.has(e.style),
        label: e.label,
        onToggle: t,
        style: e.style,
        Icon: e.icon
      });
    }));
  },
      C = m.makeStyles(function () {
    return m.createStyles({
      container: {
        transition: "background-color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
        backgroundColor: "rgba(0, 0, 0, 0.09)",
        padding: 4,
        borderRadius: 4,
        width: "100%",
        "&:hover": {
          cursor: "text"
        }
      },
      containerNotFocused: {
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.13)"
        }
      },
      root: {
        padding: "18px 12px 10px",
        "& .public-DraftEditor-content": {
          minHeight: 0,
          paddingBottom: 8
        },
        "& .public-DraftEditorPlaceholder-root": {
          marginBottom: -18,
          color: "rgba(0,0,0,0.3)"
        },
        fontFamily: ["-apple-system", "BlinkMacSystemFont", '"Segoe UI"', "Roboto", '"Helvetica Neue"', "Arial", "sans-serif", '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(",")
      },
      expanded: {
        "& .public-DraftEditor-content": {
          minHeight: 32
        }
      },
      readOnly: {
        backgroundColor: "rgba(0,0,0,0)",
        padding: 0,
        "&:hover": {
          backgroundColor: "rgba(0,0,0,0)"
        }
      },
      rootNoPadding: {
        padding: 0
      }
    });
  });

  e.CommentField = function (e) {
    var r,
        n,
        a = e.initialState,
        l = e.editorState,
        i = e.setEditorState,
        c = e.onBlurUpdate,
        u = e.children,
        d = e.render,
        y = t.useState(),
        b = y[0],
        S = y[1],
        O = t.useState(!1),
        F = O[0],
        k = O[1],
        v = t.useState(!1),
        B = v[0],
        T = v[1],
        I = t.useRef(null),
        w = t.useCallback(i || function () {}, [i]);

    function j(e) {
      B || e.getCurrentContent() === l.getCurrentContent() || T(!0), !B || a || e.getCurrentContent().hasText() || T(!1), w(e);
    }

    function x() {
      I && I.current && (I.current.blur(), k(!1)), j(a || s.EditorState.createEmpty()), T(!1);
    }

    t.useEffect(function () {
      return function () {
        b && (window.clearTimeout(b), S(void 0));
      };
    }, []);
    var P = C();
    return p.createElement("div", {
      className: o(P.container, (r = {}, r[P.containerNotFocused] = !F, r[P.readOnly] = !i, r))
    }, p.createElement("div", {
      onClick: function onClick() {
        i && I && I.current && (I.current.focus(), k(!0));
      },
      className: o(P.root, (n = {}, n[P.expanded] = F, n[P.rootNoPadding] = !i, n))
    }, p.createElement(s.Editor, {
      onFocus: function onFocus() {
        b && clearTimeout(b);
      },
      onBlur: function onBlur() {
        c && c();
        var e = window.setTimeout(function () {
          k(!1);
        }, 750);
        S(e);
      },
      blockStyleFn: g,
      customStyleMap: f,
      placeholder: "Add a comment...",
      editorState: l,
      handleKeyCommand: function handleKeyCommand(e, t) {
        var o = s.RichUtils.handleKeyCommand(t, e);
        return o ? (j(o), "handled") : "not-handled";
      },
      keyBindingFn: function keyBindingFn(e) {
        if (9 === e.keyCode) {
          var t = s.RichUtils.onTab(e, l, 4);
          return t !== l && j(t), "";
        }

        return s.getDefaultKeyBinding(e);
      },
      onChange: j,
      ref: I,
      spellCheck: !0,
      readOnly: !i
    })), p.createElement(m.Collapse, {
      in: F && !!i,
      timeout: {
        enter: 100,
        exit: 175
      }
    }, p.createElement(m.Grid, {
      container: !0,
      justify: "space-between",
      alignContent: "flex-start",
      alignItems: "flex-start"
    }, p.createElement(m.Grid, {
      item: !0
    }, p.createElement(E, {
      editorState: l,
      onToggle: function onToggle(e) {
        j(s.RichUtils.toggleInlineStyle(l, e));
      }
    }), p.createElement(h, {
      editorState: l,
      onToggle: function onToggle(e) {
        j(s.RichUtils.toggleBlockType(l, e));
      }
    })), p.createElement(m.Grid, {
      xs: !0,
      item: !0,
      container: !0,
      justify: "flex-end",
      wrap: "nowrap"
    }, d && d({
      unfocusEditor: x,
      setHasChanges: T
    }), u && u({
      unfocusEditor: x,
      setHasChanges: T
    })))));
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});